var _style, _polygon, _polygon2, _defs, _defs2, _defs3, _polygon3, _polygon4, _defs4, _defs5, _defs6, _g, _g2, _g3, _polygon5, _path, _polygon6, _polygon7, _path2, _path3, _path4, _g4, _polygon8, _polygon9, _defs7, _defs8, _defs9, _polygon0, _polygon1, _defs0, _defs1, _defs10, _g5, _g6, _g7, _g8, _polygon10, _path5, _polygon11, _polygon12, _path6, _path7, _path8, _g9, _feBlend, _feBlend2, _g0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAbducted(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 485.15 469.21",
    style: {
      enableBackground: "new 0 0 485.15 469.21"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{filter:url(#Adobe_OpacityMaskFilter);}\n\t.st2{clip-path:url(#SVGID_00000089553320160209908760000006470360518758932359_);}\n\n\t\t.st3{clip-path:url(#SVGID_00000025426228975505837020000012416085501740176257_);fill:url(#SVGID_00000171701989147044873650000013553164480893164961_);}\n\t.st4{mask:url(#SVGID_1_);fill:url(#SVGID_00000039126448273918927610000006077909343994580885_);}\n\t.st5{display:none;fill:url(#SVGID_00000020376387416760489100000015995963317844626578_);}\n\t.st6{filter:url(#Adobe_OpacityMaskFilter_00000183962141468993182760000007166380454915851914_);}\n\t.st7{clip-path:url(#SVGID_00000004547167058028109130000006473377705074312116_);}\n\n\t\t.st8{clip-path:url(#SVGID_00000092446975659901960810000016829775693486036620_);fill:url(#SVGID_00000137100466395436574160000009264703717392810640_);}\n\n\t\t.st9{mask:url(#SVGID_00000160185008103618937120000003217746264331890607_);fill:url(#SVGID_00000034079757136083374340000005383215675683827852_);}\n\t.st10{display:none;fill:url(#SVGID_00000168821023117554343380000012807953975487713165_);}\n\t.st11{display:none;}\n\t.st12{display:inline;fill:#D8E2F4;}\n\t.st13{display:inline;fill:#FFFFFF;}\n\t.st14{display:inline;}\n\t.st15{opacity:0.56;fill:#FFFFFF;enable-background:new    ;}\n\t.st16{fill:#E0E9F3;}\n\t.st17{opacity:0.36;fill:#50C6A1;enable-background:new    ;}\n\t.st18{display:inline;fill:#50C6A1;}\n\t.st19{display:inline;fill:#14336A;}\n\t.st20{display:inline;fill:#14336D;}\n\t.st21{display:inline;fill:#FFAA9D;}\n\t.st22{display:inline;fill:url(#SVGID_00000111180154561624940870000007436882359677648542_);}\n\t.st23{display:inline;fill:url(#SVGID_00000049907662943529281480000001463447565180436389_);}\n\t.st24{display:inline;fill:url(#SVGID_00000118394495052560183440000006055446791426703765_);}\n\t.st25{display:inline;fill:url(#SVGID_00000064338313458661352210000012623853082077097122_);}\n\t.st26{fill:#FFAA9D;}\n\t.st27{fill:#FF9F91;}\n\t.st28{fill:#14336A;}\n\t.st29{filter:url(#Adobe_OpacityMaskFilter_00000094581562084617722820000006344487746613473198_);}\n\t.st30{clip-path:url(#SVGID_00000070119415557810260450000003129442172890167988_);}\n\n\t\t.st31{clip-path:url(#SVGID_00000152230729674970386270000006239565915449173635_);fill:url(#SVGID_00000129918911709382690790000007733753357153233032_);}\n\n\t\t.st32{mask:url(#SVGID_00000173841461115679210350000008696728745153805713_);fill:url(#SVGID_00000067949690322233312900000003053199932756401807_);}\n\t.st33{filter:url(#Adobe_OpacityMaskFilter_00000080195669343282716520000014568056919955657353_);}\n\t.st34{clip-path:url(#SVGID_00000170972164682950114870000003252964000214585734_);}\n\n\t\t.st35{clip-path:url(#SVGID_00000015334117634536736420000012277414256179938739_);fill:url(#SVGID_00000027578953979967491400000013331828996111530654_);}\n\n\t\t.st36{mask:url(#SVGID_00000170992476827110885290000013639187156660841405_);fill:url(#SVGID_00000183951068183381627220000007612926945212496002_);}\n\t.st37{fill:url(#SVGID_00000062910181554260768020000014635545659877440447_);}\n\t.st38{display:inline;fill:#D0DFF3;}\n\t.st39{fill:#3FB790;}\n\t.st40{fill:#34916F;}\n\t.st41{fill:#4FC7A0;}\n\t.st42{fill:#3FB690;}\n\t.st43{fill:#90DAD8;}\n\t.st44{fill:#FFFFFF;}\n\t.st45{fill:#D0DAED;}\n\t.st46{fill:url(#SVGID_00000026842528190005875060000003887547686151563967_);}\n\t.st47{fill:url(#SVGID_00000072256359800708939250000016227899925176344756_);}\n\t.st48{fill:#D8E2F4;}\n\t.st49{opacity:0.56;fill:#FFFFFF;}\n\t.st50{opacity:0.36;fill:#50C6A1;}\n\t.st51{fill:#50C6A1;}\n\t.st52{fill:#14336D;}\n\t.st53{fill:url(#SVGID_00000118370747021327637090000008510558283413462956_);}\n\t.st54{fill:url(#SVGID_00000120518612784689520340000002926458924443123130_);}\n\t.st55{fill:url(#SVGID_00000090255858652795292040000002631969489893040525_);}\n\t.st56{fill:url(#SVGID_00000143581386120125588980000000755354743512849569_);}\n\t.st57{filter:url(#Adobe_OpacityMaskFilter_00000059279091620393817320000011672651161573136796_);}\n\t.st58{filter:url(#Adobe_OpacityMaskFilter_00000139284539614274678830000002592618015674897823_);}\n\n\t\t.st59{mask:url(#SVGID_00000100359562396285449270000013805175768074663357_);fill:url(#SVGID_00000142886387192788555100000015644367150986820012_);}\n\t.st60{fill:url(#SVGID_00000174584569200492104550000013058579212616121251_);}\n\t.st61{fill:#D0DFF3;}\n")), /*#__PURE__*/React.createElement("g", null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1,1 2,1 1,2  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-1,-1 -2,-1 -1,-2  "
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 15.94,
    y: 0,
    width: 469.2,
    height: 469.2
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 15.94,
    y: 0,
    width: 469.2,
    height: 469.2,
    id: "SVGID_1_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000105427302643395693920000010861198519077116819_",
    points: "1,1 2,1 1,2  "
  }))), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000158005964387591197780000017928021583125207721_",
    points: "-1,-1 -2,-1 -1,-2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000043440971580405894610000006272384593590101662_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000105427302643395693920000010861198519077116819_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000097493992851557568240000000865440767605594512_",
    style: {
      clipPath: "url(#SVGID_00000043440971580405894610000006272384593590101662_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000158005964387591197780000017928021583125207721_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000077309001137642432520000018313861538840815033_",
    gradientUnits: "userSpaceOnUse",
    x1: 250.54,
    y1: 49.4059,
    x2: 250.54,
    y2: 518.6059,
    gradientTransform: "matrix(1 0 0 -1 0 472)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      clipPath: "url(#SVGID_00000097493992851557568240000000865440767605594512_)",
      fill: "url(#SVGID_00000077309001137642432520000018313861538840815033_)"
    },
    cx: 250.54,
    cy: 234.6,
    r: 234.6
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160172396452277203750000006097264070772881296_",
    gradientUnits: "userSpaceOnUse",
    x1: 250.54,
    y1: 49.4059,
    x2: 250.54,
    y2: 518.6059,
    gradientTransform: "matrix(1 0 0 -1 0 472)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      mask: "url(#SVGID_1_)",
      fill: "url(#SVGID_00000160172396452277203750000006097264070772881296_)"
    },
    cx: 250.54,
    cy: 234.6,
    r: 234.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072964572736192469150000017985179490817029804_",
    gradientUnits: "userSpaceOnUse",
    x1: 250.54,
    y1: 49.4059,
    x2: 250.54,
    y2: 518.6059,
    gradientTransform: "matrix(1 0 0 -1 0 472)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEFEFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBF3FF"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      display: "none",
      fill: "url(#SVGID_00000072964572736192469150000017985179490817029804_)"
    },
    cx: 250.54,
    cy: 234.6,
    r: 234.6
  }), /*#__PURE__*/React.createElement("g", null, _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1,1 2,1 1,2  "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-1,-1 -2,-1 -1,-2  "
  })), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000122713330389782849210000006837637668948203168_",
    filterUnits: "userSpaceOnUse",
    x: 16.53,
    y: 245.16,
    width: 466.74,
    height: 167.54
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 16.53,
    y: 245.16,
    width: 466.74,
    height: 167.54,
    id: "SVGID_00000100340394416992961120000017463004992651270560_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000122713330389782849210000006837637668948203168_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000024703275924696615240000017870227468938436527_",
    points: "1,1 2,1 1,2  "
  }))), _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000027578611618856708530000014207059023292323481_",
    points: "-1,-1 -2,-1 -1,-2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000096034684539778894330000015944972133227672740_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000024703275924696615240000017870227468938436527_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000115500032823677595140000009238569792176393391_",
    style: {
      clipPath: "url(#SVGID_00000096034684539778894330000015944972133227672740_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000027578611618856708530000014207059023292323481_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000020388046756668543440000000631230633085835192_",
    gradientUnits: "userSpaceOnUse",
    x1: 249.9,
    y1: 67.5815,
    x2: 249.9,
    y2: 201.741,
    gradientTransform: "matrix(1 0 0 -1 0 472)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8395,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000115500032823677595140000009238569792176393391_)",
      fill: "url(#SVGID_00000020388046756668543440000000631230633085835192_)"
    },
    d: " M483.27,264.43c-25.85-11.3-59.52-16.7-80.54-8.83c-19.73,7.39-16.55,22.07-36.8,28.13c-32.67,9.78-55.3-24.11-103.91-22.5 c-43.25,1.43-58.24,29.35-90.92,22.5c-20.38-4.27-24.24-17.16-38.74-26.25c-24.31-15.24-70.97-15.08-115.83-6.36 c4.09,58.71,29.76,111.46,69.15,150.37c44.31,8.2,92.51,12.57,139.54,10.83c82.64-3.07,166.22-25.2,223.14-51.55 C466.58,332.27,478.81,299.56,483.27,264.43z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124880874542736062960000006444257215560287892_",
    gradientUnits: "userSpaceOnUse",
    x1: 249.9,
    y1: 67.5815,
    x2: 249.9,
    y2: 201.741,
    gradientTransform: "matrix(1 0 0 -1 0 472)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8395,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000100340394416992961120000017463004992651270560_)",
      fill: "url(#SVGID_00000124880874542736062960000006444257215560287892_)"
    },
    d: " M483.27,264.43c-25.85-11.3-59.52-16.7-80.54-8.83c-19.73,7.39-16.55,22.07-36.8,28.13c-32.67,9.78-55.3-24.11-103.91-22.5 c-43.25,1.43-58.24,29.35-90.92,22.5c-20.38-4.27-24.24-17.16-38.74-26.25c-24.31-15.24-70.97-15.08-115.83-6.36 c4.09,58.71,29.76,111.46,69.15,150.37c44.31,8.2,92.51,12.57,139.54,10.83c82.64-3.07,166.22-25.2,223.14-51.55 C466.58,332.27,478.81,299.56,483.27,264.43z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005978700408424245680000002810366835184271277_",
    gradientUnits: "userSpaceOnUse",
    x1: 249.9,
    y1: 67.5815,
    x2: 249.9,
    y2: 201.741,
    gradientTransform: "matrix(1 0 0 -1 0 472)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEFEFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8395,
    style: {
      stopColor: "#EBF3FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "none",
      fill: "url(#SVGID_00000005978700408424245680000002810366835184271277_)"
    },
    d: "M483.27,264.43 c-25.85-11.3-59.52-16.7-80.54-8.83c-19.73,7.39-16.55,22.07-36.8,28.13c-32.67,9.78-55.3-24.11-103.91-22.5 c-43.25,1.43-58.24,29.35-90.92,22.5c-20.38-4.27-24.24-17.16-38.74-26.25c-24.31-15.24-70.97-15.08-115.83-6.36 c4.09,58.71,29.76,111.46,69.15,150.37c44.31,8.2,92.51,12.57,139.54,10.83c82.64-3.07,166.22-25.2,223.14-51.55 C466.58,332.27,478.81,299.56,483.27,264.43z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M380.55,95.54h-56.73c-3.32,0-6.35-1.2-8.7-3.19c-2.9-2.46-4.74-6.14-4.74-10.24l0,0 c0-3.71,1.5-7.07,3.94-9.5c2.43-2.43,5.79-3.94,9.5-3.94h56.73c3.71,0,7.07,1.5,9.5,3.94c2.43,2.43,3.94,5.79,3.94,9.5l0,0 c0,3.71-1.5,7.07-3.94,9.5C387.62,94.04,384.26,95.54,380.55,95.54z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st12",
    cx: 347.3,
    cy: 73.01,
    r: 20.36
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M92.32,166.38H17.68c-4.88,0-9.3-1.98-12.5-5.18C1.98,158,0,153.58,0,148.7l0,0c0-3.48,1.01-6.73,2.74-9.46 c3.14-4.94,8.65-8.21,14.93-8.21h74.64c4.88,0,9.3,1.98,12.5,5.18s5.18,7.62,5.18,12.5l0,0c0,4.55-1.72,8.71-4.55,11.84 C102.21,164.12,97.53,166.38,92.32,166.38z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 48.57,
    cy: 136.74,
    r: 26.78
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M252.38,94.6c1.29,6.25,1.25,12.47,0.07,18.36l-84.98,14.78c-2.62-4.36-4.56-9.22-5.64-14.49 c-5.15-25.01,10.94-49.45,35.95-54.6C222.78,53.49,247.23,69.59,252.38,94.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M167.01,130c-0.62-0.13-1.18-0.51-1.52-1.07c-2.82-4.69-4.81-9.81-5.92-15.21 c-5.4-26.21,11.53-51.93,37.75-57.33c12.7-2.62,25.65-0.13,36.48,7s18.23,18.05,20.85,30.75l0,0c1.32,6.42,1.35,12.9,0.08,19.27 c-0.19,0.94-0.93,1.66-1.87,1.82l-84.98,14.78C167.58,130.06,167.29,130.05,167.01,130z M215.72,60.86 c-5.61-1.13-11.53-1.18-17.48,0.05c-23.72,4.89-39.04,28.16-34.15,51.87c0.9,4.37,2.44,8.54,4.57,12.4l81.8-14.23 c0.86-5.26,0.74-10.6-0.35-15.89C246.46,77.29,232.47,64.23,215.72,60.86z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M172.31,90.93c-0.2,0-0.41-0.04-0.61-0.11c-0.89-0.33-1.33-1.32-1-2.21c3-7.93,16.11-21.69,25.4-22.42 c0.96-0.08,1.77,0.63,1.84,1.57c0.07,0.94-0.63,1.77-1.57,1.84c-7.23,0.57-19.56,12.53-22.46,20.21 C173.65,90.51,173,90.93,172.31,90.93z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9794 -0.2018 0.2018 0.9794 -18.0301 44.3474)",
    className: "st18",
    cx: 208.48,
    cy: 110.6,
    rx: 75.51,
    ry: 27
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M236.9,104.75c1.16,5.61-10.63,12.78-26.32,16.02c-15.69,3.23-29.36,1.3-30.51-4.31 c-1.16-5.61,10.63-12.78,26.32-16.02C222.08,97.21,235.74,99.14,236.9,104.75z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st11"
  }, _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "305.72,343.07 308.61,346.65 328.1,335.74 322.62,332.85  "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M305.72,343.07l16.9-10.22c0,0-1.58-4.36-2.22-5.74l-18.74,11.58L305.72,343.07z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029005816867182438560000016386436380215056024_",
    gradientUnits: "userSpaceOnUse",
    x1: 84.7343,
    y1: -274.1794,
    x2: 58.6554,
    y2: -273.8257,
    gradientTransform: "matrix(0.9633 -0.2685 -0.2685 -0.9633 131.6844 61.5592)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#14336D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0E2253"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "url(#SVGID_00000029005816867182438560000016386436380215056024_)"
    },
    d: "M259.39,270.28 c0,0,26.53,15.72,37.42,25.83c10.89,10.11,17.54,17.88,24.12,30.68L301.1,339.1c0,0-18.08-21.07-30.62-29.06 s-34.03-27.99-34.03-27.99L259.39,270.28z"
  }), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "223.95,330.21 219.9,335.72 240.81,351.49 241.59,344.17  "
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "223.95,330.21 241.59,344.17 248.15,339.86 228.3,324.62  "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M227.73,294.69c0,0,6.18,8.58,16.29,8.84c0,0-15.31,18.97-16.7,20.39l21.4,16.47c0,0,19.68-12.43,24.41-25.98 c4.74-13.55-3.83-20.7-11.54-25.97c-7.73-5.29-17.51-8.52-17.51-8.52L227.73,294.69z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M278.91,246.89c0,0,4.44-6.53,4.96-6.33c0.52,0.19,0.63,3.17,0.63,3.17s3.11-4.04,5.25-2.86 s0.19,13.57-4.39,16.29L278.91,246.89z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000037660204666776466430000012175880232453648829_",
    gradientUnits: "userSpaceOnUse",
    x1: 75.2975,
    y1: -215.3004,
    x2: 70.1457,
    y2: -237.9467,
    gradientTransform: "matrix(0.9633 -0.2685 -0.2685 -0.9633 131.6844 61.5592)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3162DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9649,
    style: {
      stopColor: "#173DB8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "url(#SVGID_00000037660204666776466430000012175880232453648829_)"
    },
    d: "M239.3,237.96 c0,0,8.34-0.91,12.94,4.61c4.6,5.52,7.29,9.87,7.29,9.87s18.71-6.91,19.86-6.44c1.15,0.47,6.54,8.83,7.01,10.52 c0.47,1.68-8.88,12.9-27,13.76C241.26,271.14,234.55,244.45,239.3,237.96z"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M193.12,257.63c0,0-8.23-5.57-8.94-5.16s1.74,2.85,1.57,3.08s-4.04,1.83-3.14,6.13s2.92,7.1,3.81,7.74 L193.12,257.63z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083086590952763652040000008882070037685462963_",
    gradientUnits: "userSpaceOnUse",
    x1: 27.2708,
    y1: -207.141,
    x2: 3.319,
    y2: -232.9465,
    gradientTransform: "matrix(0.9633 -0.2685 -0.2685 -0.9633 131.6844 61.5592)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3162DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9649,
    style: {
      stopColor: "#173DB8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "url(#SVGID_00000083086590952763652040000008882070037685462963_)"
    },
    d: "M223.78,241.44 c-0.61,0.15-7.16,2.72-9.64,6.48c-2.48,3.75-8,16.94-8.28,17.01c-0.28,0.08-11.54-8.24-12.88-7.98 c-1.34,0.26-7.47,10.99-7.54,12.31c-0.07,1.32,8.45,13.94,16.76,17.27s12.36,2.64,15.07-0.51 C219.99,282.88,224.39,241.29,223.78,241.44z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000033346750700724925200000001756333659079466898_",
    gradientUnits: "userSpaceOnUse",
    x1: 47.462,
    y1: -236.7148,
    x2: 52.2258,
    y2: -275.7632,
    gradientTransform: "matrix(0.9633 -0.2685 -0.2685 -0.9633 131.6844 61.5592)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3162DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9649,
    style: {
      stopColor: "#173DB8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "url(#SVGID_00000033346750700724925200000001756333659079466898_)"
    },
    d: "M261.56,270.63 c1.5,2.85-28.67,27.57-32.35,26.69c-3.68-0.88-8.89-12.24-9.87-20.14c-0.98-7.9,0.3-30.9,2.18-34.64 c0.76-1.5,21.16-5.66,21.25-4.28C244.25,261.17,259.1,265.96,261.56,270.63z"
  }), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M237.76,228.75l1.59,5.39l-0.82,0.2c0,0,0.6,4.66-2.76,4.84c-0.97,0.05-2.34-0.4-2.63-0.15 c-0.35,0.29-0.18,1.57-0.17,1.95c0.03,1.45-5.09,1.4-4.71-0.2c0.36-1.52,0.95-3.63,0.58-4.06c-1.29-1.52-2.73-5.79,1.23-8.45 C233.23,226.13,237.21,226.9,237.76,228.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M228.27,240.77c0.36-1.52,0.95-3.63,0.58-4.06c0,0,2.62,2.31,4.43,2.26h0.01c-0.06,0.01-0.11,0.03-0.14,0.05 c-0.35,0.29-0.18,1.57-0.17,1.95C233.01,242.42,227.89,242.37,228.27,240.77z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M231.18,233.44c-2.14,0.22,0.4,4.41-1.89,4.88s-5.22-4-4.63-8.25s3.79-4.91,6.92-5.23 c3.13-0.32,7.17,0.01,7.8,2.27c1.51,5.44-6.2,2.67-6.17,4.42c0.02,1.36,0.54,5.15,1.87,4.87s2.37-1.73,3.48-1.75 c0.64-0.01,4.27,6.67,0.05,8.1c-4.18,1.42-6.29-2.03-6.25-5.33C232.4,234.3,232.23,233.33,231.18,233.44z"
  })))), /*#__PURE__*/React.createElement("g", null, _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1,1 2,1 1,2  "
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-1,-1 -2,-1 -1,-2  "
  })), _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000004539247586531748560000006432017166269645225_",
    filterUnits: "userSpaceOnUse",
    x: 165.96,
    y: 98.87,
    width: 230.93,
    height: 334.97
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 165.96,
    y: 98.87,
    width: 230.93,
    height: 334.97,
    id: "SVGID_00000128464078070160616780000010935694164003097738_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000004539247586531748560000006432017166269645225_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000023959918803633428290000010014294462821998478_",
    points: "1,1 2,1 1,2  "
  }))), _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000054948119208315861720000003464104955199629751_",
    points: "-1,-1 -2,-1 -1,-2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000180362528205748565270000007551224405272396990_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000023959918803633428290000010014294462821998478_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000069381559729585982150000006481974183582347966_",
    style: {
      clipPath: "url(#SVGID_00000180362528205748565270000007551224405272396990_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000054948119208315861720000003464104955199629751_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000059305662730193803260000001029970627364089521_",
    gradientUnits: "userSpaceOnUse",
    x1: 231.5083,
    y1: 716.9001,
    x2: 369.7629,
    y2: 439.2558,
    gradientTransform: "matrix(0.9803 0.1975 0.1975 -0.9803 -182.1583 736.9874)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000069381559729585982150000006481974183582347966_)",
      fill: "url(#SVGID_00000059305662730193803260000001029970627364089521_)"
    },
    d: " M236.9,104.75l159.99,329.09l-230.93-2.33l14.1-315.06c-1.16-5.61,10.63-12.78,26.32-16.02 C222.08,97.21,235.74,99.14,236.9,104.75z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000042706993799654259710000016921077034972352190_",
    gradientUnits: "userSpaceOnUse",
    x1: 231.5083,
    y1: 716.9001,
    x2: 369.7629,
    y2: 439.2558,
    gradientTransform: "matrix(0.9803 0.1975 0.1975 -0.9803 -182.1583 736.9874)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000128464078070160616780000010935694164003097738_)",
      fill: "url(#SVGID_00000042706993799654259710000016921077034972352190_)"
    },
    d: " M236.9,104.75l159.99,329.09l-230.93-2.33l14.1-315.06c-1.16-5.61,10.63-12.78,26.32-16.02C222.08,97.21,235.74,99.14,236.9,104.75 z"
  })), /*#__PURE__*/React.createElement("g", null, _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1,1 2,1 1,2  "
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-1,-1 -2,-1 -1,-2  "
  })), _defs0 || (_defs0 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000085937304959547920790000012561289031253619621_",
    filterUnits: "userSpaceOnUse",
    x: 165.96,
    y: 98.87,
    width: 230.93,
    height: 334.97
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 165.96,
    y: 98.87,
    width: 230.93,
    height: 334.97,
    id: "SVGID_00000155138461949308853860000003352778774770626714_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000085937304959547920790000012561289031253619621_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs1 || (_defs1 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000086688514327829735300000010006473911770380986_",
    points: "1,1 2,1 1,2  "
  }))), _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000023969588292401112340000007881605595227006617_",
    points: "-1,-1 -2,-1 -1,-2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000096050008672147004770000012799392024541572506_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000086688514327829735300000010006473911770380986_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000130635212779463946650000002745969855365133481_",
    style: {
      clipPath: "url(#SVGID_00000096050008672147004770000012799392024541572506_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000023969588292401112340000007881605595227006617_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000166649143085296957010000007244593695155292297_",
    gradientUnits: "userSpaceOnUse",
    x1: 247.1631,
    y1: 685.4619,
    x2: 385.4178,
    y2: 407.8175,
    gradientTransform: "matrix(0.9803 0.1975 0.1975 -0.9803 -182.1583 736.9874)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000130635212779463946650000002745969855365133481_)",
      fill: "url(#SVGID_00000166649143085296957010000007244593695155292297_)"
    },
    d: " M236.9,104.75l159.99,329.09l-230.93-2.33l14.1-315.06c-1.16-5.61,10.63-12.78,26.32-16.02 C222.08,97.21,235.74,99.14,236.9,104.75z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000060010265446952352470000013435806130861122691_",
    gradientUnits: "userSpaceOnUse",
    x1: 247.1631,
    y1: 685.4619,
    x2: 385.4178,
    y2: 407.8175,
    gradientTransform: "matrix(0.9803 0.1975 0.1975 -0.9803 -182.1583 736.9874)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000155138461949308853860000003352778774770626714_)",
      fill: "url(#SVGID_00000060010265446952352470000013435806130861122691_)"
    },
    d: " M236.9,104.75l159.99,329.09l-230.93-2.33l14.1-315.06c-1.16-5.61,10.63-12.78,26.32-16.02C222.08,97.21,235.74,99.14,236.9,104.75 z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170996310772766427740000016578685407387528868_",
    gradientUnits: "userSpaceOnUse",
    x1: 247.1631,
    y1: 685.4619,
    x2: 385.4178,
    y2: 407.8175,
    gradientTransform: "matrix(0.9803 0.1975 0.1975 -0.9803 -182.1583 736.9874)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    style: {
      stopColor: "#50C6A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#50C6A1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000170996310772766427740000016578685407387528868_)"
    },
    d: "M236.9,104.75l159.99,329.09l-230.93-2.33 l14.1-315.06c-1.16-5.61,10.63-12.78,26.32-16.02C222.08,97.21,235.74,99.14,236.9,104.75z"
  }), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st11"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st38",
    cx: 176.74,
    cy: 431.25,
    rx: 17.49,
    ry: 2.59
  }), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M153.06,353.16c-0.61,3.06,3.06,3.67,3.67,7.96c0.61,4.29-1.22,5.51-0.61,7.96 c0.61,2.45,4.29,3.06,4.9,9.18s-1.84,5.51-1.22,9.18c0.61,3.67,4.29,3.67,4.9,6.73s0.61,7.35,1.84,11.02 c1.22,3.67,4.9,9.18,6.73,9.18c1.84,0,6.73-10.41,5.51-13.47s-3.06-3.67-3.06-6.12s2.45-8.57,1.84-12.86 c-0.61-4.29-6.12-6.12-6.73-9.18s1.22-11.02-3.06-14.69C163.46,354.39,153.67,350.1,153.06,353.16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M172.98,413.33c-0.17,0-0.31-0.14-0.31-0.31c0-0.08-0.05-8.03-2.38-10.37c-2.36-2.37-3.71-9.6-4.37-23.46 c-0.6-12.6-9.63-22.97-9.72-23.07c-0.11-0.13-0.1-0.32,0.03-0.43s0.32-0.1,0.43,0.03c0.09,0.1,9.26,10.64,9.87,23.45 c0.64,13.51,1.98,20.84,4.2,23.06c2.51,2.51,2.56,10.46,2.56,10.8C173.29,413.19,173.15,413.33,172.98,413.33L172.98,413.33z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M209.09,362.43c2.16,2.16-4.9,3.06-5.51,7.35s-0.61,6.12-3.06,8.57s-6.12,3.06-5.51,6.73s1.84,7.35,0,9.18 c-1.84,1.84-6.12,1.84-7.35,4.9c-1.22,3.06-0.61,6.73-3.06,9.79s-6.12,9.18-9.18,7.96s-1.22-15.3,0-17.75s2.45-4.29,2.45-6.12 s-0.61-4.9,0.61-7.96s7.96-4.29,8.57-6.12c0.61-1.84,1.22-11.63,4.9-14.08C195.62,362.43,205.42,358.76,209.09,362.43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M176.37,415.86c-0.05,0-0.11-0.01-0.16-0.04c-0.14-0.09-0.19-0.28-0.1-0.42c0.02-0.04,2.48-4.14,2.99-6.21 c0.13-0.53,0.29-1.34,0.48-2.28c0.68-3.4,1.7-8.53,3.27-10.11c2.28-2.28,5.93-9.28,8.49-18.23 c3.15-11.03,13.57-14.26,13.67-14.29c0.16-0.05,0.33,0.04,0.38,0.21c0.05,0.16-0.04,0.33-0.21,0.38 c-0.1,0.03-10.2,3.17-13.26,13.87c-2.59,9.05-6.31,16.16-8.65,18.5c-1.44,1.44-2.48,6.67-3.1,9.79 c-0.19,0.94-0.35,1.76-0.49,2.31c-0.54,2.16-2.96,6.21-3.06,6.38C176.58,415.81,176.48,415.86,176.37,415.86z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M175.59,369.44c-7.35,0.61-4.9,22.65-4.9,22.65c1.84,18.98,4.28,27.55,6.12,28.16 c1.84,0.61,5.51-26.93,5.51-33.67C182.32,386.58,182.94,368.83,175.59,369.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M176.51,417.18c-0.01,0-0.03,0-0.04,0c-0.17-0.02-0.29-0.17-0.27-0.34c2.42-19.93-0.58-44.97-0.61-45.23 c-0.02-0.17,0.1-0.32,0.27-0.34c0.16-0.02,0.32,0.1,0.34,0.27c0.03,0.25,3.04,25.37,0.61,45.37 C176.79,417.07,176.66,417.18,176.51,417.18z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M185.63,431.12H167c-0.62,0-1.15-0.38-1.22-0.88l-2.71-19.31c-0.12-0.87,0.55-1.65,1.43-1.65h23.61 c0.88,0,1.55,0.78,1.43,1.65l-2.71,19.31C186.78,430.74,186.26,431.12,185.63,431.12z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000028294668698381112770000015655824510221421494_",
    gradientUnits: "userSpaceOnUse",
    x1: 250.9699,
    y1: 422.9906,
    x2: 250.9699,
    y2: -46.2164
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEFEFD",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBF3FF"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000028294668698381112770000015655824510221421494_)"
    },
    cx: 250.97,
    cy: 235,
    r: 234.6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000001645521154547359670000012094476092700458371_",
    gradientUnits: "userSpaceOnUse",
    x1: 250.3239,
    y1: 404.8151,
    x2: 250.3239,
    y2: 270.6555
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEFEFD",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8395,
    style: {
      stopColor: "#EBF3FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000001645521154547359670000012094476092700458371_)"
    },
    d: "M483.69,264.83 c-25.85-11.3-59.52-16.7-80.54-8.83c-19.73,7.39-16.55,22.07-36.8,28.13c-32.67,9.78-55.3-24.11-103.91-22.5 c-43.25,1.43-58.24,29.35-90.92,22.5c-20.38-4.27-24.24-17.16-38.74-26.25c-24.31-15.24-70.97-15.08-115.83-6.36 c4.09,58.71,29.76,111.46,69.15,150.37c44.31,8.2,92.51,12.57,139.54,10.83c82.64-3.07,166.22-25.2,223.14-51.55 C467.01,332.66,479.24,299.96,483.69,264.83z"
  }), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M380.98,95.94h-56.73c-3.32,0-6.35-1.2-8.7-3.19c-2.9-2.46-4.74-6.14-4.74-10.24v0c0-3.71,1.5-7.07,3.94-9.5 c2.43-2.43,5.79-3.94,9.5-3.94h56.73c3.71,0,7.07,1.5,9.5,3.94c2.43,2.43,3.94,5.79,3.94,9.5v0c0,3.71-1.5,7.07-3.94,9.5 C388.05,94.43,384.69,95.94,380.98,95.94z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st48",
    cx: 347.73,
    cy: 73.41,
    r: 20.36
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M92.74,166.77H18.1c-4.88,0-9.3-1.98-12.5-5.18c-3.2-3.2-5.18-7.62-5.18-12.5v0c0-3.48,1.01-6.73,2.74-9.46 c3.14-4.94,8.65-8.21,14.93-8.21h74.64c4.88,0,9.3,1.98,12.5,5.18c3.2,3.2,5.18,7.62,5.18,12.5v0c0,4.55-1.72,8.71-4.55,11.84 C102.64,164.52,97.95,166.77,92.74,166.77z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st44",
    cx: 49,
    cy: 137.13,
    r: 26.78
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M252.81,94.99c1.29,6.25,1.25,12.47,0.07,18.36l-84.98,14.78c-2.62-4.36-4.56-9.22-5.64-14.49 c-5.15-25.01,10.94-49.45,35.95-54.6C223.21,53.89,247.65,69.99,252.81,94.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M167.44,130.4c-0.62-0.13-1.18-0.51-1.52-1.07c-2.82-4.69-4.81-9.81-5.92-15.21 c-5.4-26.21,11.53-51.93,37.75-57.33c12.7-2.62,25.65-0.13,36.48,7c10.83,7.13,18.23,18.05,20.85,30.75l0,0 c1.32,6.42,1.35,12.9,0.08,19.27c-0.19,0.94-0.93,1.66-1.87,1.82l-84.98,14.78C168,130.46,167.71,130.45,167.44,130.4z  M216.14,61.26c-5.61-1.13-11.53-1.18-17.48,0.05c-23.72,4.89-39.04,28.16-34.15,51.87c0.9,4.37,2.44,8.54,4.57,12.4l81.8-14.23 c0.86-5.26,0.74-10.6-0.35-15.89C246.88,77.69,232.9,64.63,216.14,61.26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M172.73,91.33c-0.2,0-0.41-0.04-0.61-0.11c-0.89-0.33-1.33-1.32-1-2.21c3-7.93,16.11-21.69,25.4-22.42 c0.96-0.08,1.77,0.63,1.84,1.57c0.07,0.94-0.63,1.77-1.57,1.84c-7.23,0.57-19.56,12.53-22.46,20.21 C174.08,90.91,173.43,91.33,172.73,91.33z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9794 -0.2018 0.2018 0.9794 -18.1001 44.4328)",
    className: "st51",
    cx: 208.91,
    cy: 111,
    rx: 75.51,
    ry: 27
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M237.32,105.15c1.16,5.61-10.63,12.78-26.32,16.02c-15.69,3.23-29.36,1.3-30.51-4.31 c-1.16-5.61,10.63-12.78,26.32-16.02C222.51,97.61,236.17,99.54,237.32,105.15z"
  }))), /*#__PURE__*/React.createElement("g", null, _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st52",
    points: "306.15,343.46 309.04,347.05 328.52,336.13 323.05,333.24  "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M306.15,343.46l16.9-10.22c0,0-1.58-4.36-2.22-5.74l-18.74,11.58L306.15,343.46z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137850411493706712250000015396144776465400494_",
    gradientUnits: "userSpaceOnUse",
    x1: 193.1763,
    y1: 565.4701,
    x2: 167.0974,
    y2: 565.1164,
    gradientTransform: "matrix(0.9633 -0.2685 0.2685 0.9633 -50.5622 -189.5262)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#14336D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0E2253"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000137850411493706712250000015396144776465400494_)"
    },
    d: "M259.82,270.68 c0,0,26.53,15.72,37.42,25.83c10.89,10.11,17.54,17.88,24.12,30.68l-19.84,12.31c0,0-18.08-21.07-30.62-29.06 c-12.54-7.99-34.03-27.99-34.03-27.99L259.82,270.68z"
  }), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st52",
    points: "224.38,330.6 220.33,336.11 241.24,351.89 242.02,344.56  "
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "224.38,330.6 242.02,344.56 248.58,340.26 228.73,325.02  "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M228.16,295.09c0,0,6.18,8.58,16.29,8.84c0,0-15.31,18.97-16.7,20.39l21.4,16.47c0,0,19.68-12.43,24.41-25.98 c4.74-13.55-3.83-20.7-11.54-25.97c-7.73-5.29-17.51-8.52-17.51-8.52L228.16,295.09z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M279.34,247.29c0,0,4.44-6.53,4.96-6.33c0.52,0.19,0.63,3.17,0.63,3.17s3.11-4.04,5.25-2.86 s0.19,13.57-4.39,16.29L279.34,247.29z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000167378534368008617870000007699265787942180242_",
    gradientUnits: "userSpaceOnUse",
    x1: 183.7388,
    y1: 506.5891,
    x2: 178.587,
    y2: 529.2355,
    gradientTransform: "matrix(0.9633 -0.2685 0.2685 0.9633 -50.5622 -189.5262)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3162DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9649,
    style: {
      stopColor: "#173DB8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000167378534368008617870000007699265787942180242_)"
    },
    d: "M239.73,238.36c0,0,8.34-0.91,12.94,4.61 c4.6,5.52,7.29,9.87,7.29,9.87s18.71-6.91,19.86-6.44c1.15,0.47,6.54,8.83,7.01,10.52c0.47,1.68-8.88,12.9-27,13.76 C241.69,271.53,234.98,244.85,239.73,238.36z"
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M193.54,258.03c0,0-8.23-5.57-8.94-5.16c-0.71,0.41,1.74,2.85,1.57,3.08c-0.17,0.23-4.04,1.83-3.14,6.13 c0.9,4.3,2.92,7.1,3.81,7.74L193.54,258.03z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000061432057862742242840000006907562067644492714_",
    gradientUnits: "userSpaceOnUse",
    x1: 135.7194,
    y1: 498.4359,
    x2: 111.7675,
    y2: 524.2415,
    gradientTransform: "matrix(0.9633 -0.2685 0.2685 0.9633 -50.5622 -189.5262)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3162DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9649,
    style: {
      stopColor: "#173DB8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000061432057862742242840000006907562067644492714_)"
    },
    d: "M224.21,241.83 c-0.61,0.15-7.16,2.72-9.64,6.48c-2.48,3.75-8,16.94-8.28,17.01c-0.28,0.08-11.54-8.24-12.88-7.98 c-1.34,0.26-7.47,10.99-7.54,12.31s8.45,13.94,16.76,17.27c8.31,3.33,12.36,2.64,15.07-0.51 C220.41,283.28,224.82,241.68,224.21,241.83z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000179637864798381875770000003684096916054247573_",
    gradientUnits: "userSpaceOnUse",
    x1: 155.9067,
    y1: 528.0034,
    x2: 160.6706,
    y2: 567.0518,
    gradientTransform: "matrix(0.9633 -0.2685 0.2685 0.9633 -50.5622 -189.5262)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3162DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9649,
    style: {
      stopColor: "#173DB8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000179637864798381875770000003684096916054247573_)"
    },
    d: "M261.99,271.03 c1.5,2.85-28.67,27.57-32.35,26.69c-3.68-0.88-8.89-12.24-9.87-20.14c-0.98-7.9,0.3-30.9,2.18-34.64 c0.76-1.5,21.16-5.66,21.25-4.28C244.68,261.57,259.53,266.35,261.99,271.03z"
  }), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M238.19,229.14l1.59,5.39l-0.82,0.2c0,0,0.6,4.66-2.76,4.84c-0.97,0.05-2.34-0.4-2.63-0.15 c-0.35,0.29-0.18,1.57-0.17,1.95c0.03,1.45-5.09,1.4-4.71-0.2c0.36-1.52,0.95-3.63,0.58-4.06c-1.29-1.52-2.73-5.79,1.23-8.45 C233.66,226.52,237.64,227.3,238.19,229.14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M228.7,241.17c0.36-1.52,0.95-3.63,0.58-4.06c0,0,2.62,2.31,4.43,2.26c0,0,0.01,0,0.01,0 c-0.06,0.01-0.11,0.03-0.14,0.05c-0.35,0.29-0.18,1.57-0.17,1.95C233.44,242.82,228.31,242.77,228.7,241.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M231.61,233.84c-2.14,0.22,0.4,4.41-1.89,4.88c-2.29,0.47-5.22-4-4.63-8.25c0.59-4.25,3.79-4.91,6.92-5.23 c3.13-0.32,7.17,0.01,7.8,2.27c1.51,5.44-6.2,2.67-6.17,4.42c0.02,1.36,0.54,5.15,1.87,4.87c1.33-0.28,2.37-1.73,3.48-1.75 c0.64-0.01,4.27,6.67,0.05,8.1c-4.18,1.42-6.29-2.03-6.25-5.33C232.83,234.7,232.65,233.73,231.61,233.84z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000047765262974240390520000007549907047732319663_",
    filterUnits: "userSpaceOnUse",
    x: 166.39,
    y: 99.27,
    width: 230.93,
    height: 334.97
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend || (_feBlend = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 166.39,
    y: 99.27,
    width: 230.93,
    height: 334.97,
    id: "SVGID_00000111169270659587250580000000383401817981612957_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000047765262974240390520000007549907047732319663_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000054263335991326379330000010378115367225877383_",
    filterUnits: "userSpaceOnUse",
    x: 166.39,
    y: 99.27,
    width: 230.93,
    height: 334.97
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend2 || (_feBlend2 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 166.39,
    y: 99.27,
    width: 230.93,
    height: 334.97,
    id: "SVGID_00000111169270659587250580000000383401817981612957_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000054263335991326379330000010378115367225877383_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000180343457932455705970000001281861512754341539_",
    gradientUnits: "userSpaceOnUse",
    x1: 201.5921,
    y1: -65.6251,
    x2: 339.8469,
    y2: 212.0192,
    gradientTransform: "matrix(0.9803 0.1975 -0.1975 0.9803 -14.6412 138.7584)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000111169270659587250580000000383401817981612957_)",
      fill: "url(#SVGID_00000180343457932455705970000001281861512754341539_)"
    },
    d: " M237.32,105.15l159.99,329.09l-230.93-2.33l14.1-315.06c-1.16-5.61,10.63-12.78,26.32-16.02 C222.51,97.61,236.17,99.54,237.32,105.15z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000030462624295551694180000011193431633295330206_",
    gradientUnits: "userSpaceOnUse",
    x1: 284.651,
    y1: 441.8083,
    x2: 181.1218,
    y2: 118.7972
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#50C6A1",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8054,
    style: {
      stopColor: "#50C6A1",
      stopOpacity: 0.7755
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9346,
    style: {
      stopColor: "#50C6A1",
      stopOpacity: 0.9
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000030462624295551694180000011193431633295330206_)"
    },
    d: "M237.32,105.15l159.99,329.09 l-230.93-2.33l14.1-315.06c-1.16-5.61,10.63-12.78,26.32-16.02C222.51,97.61,236.17,99.54,237.32,105.15z"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st61",
    cx: 177.17,
    cy: 431.65,
    rx: 17.49,
    ry: 2.59
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M153.49,353.56c-0.61,3.06,3.06,3.67,3.67,7.96c0.61,4.29-1.22,5.51-0.61,7.96 c0.61,2.45,4.29,3.06,4.9,9.18c0.61,6.12-1.84,5.51-1.22,9.18c0.61,3.67,4.29,3.67,4.9,6.73c0.61,3.06,0.61,7.35,1.84,11.02 c1.22,3.67,4.9,9.18,6.73,9.18c1.84,0,6.73-10.41,5.51-13.47c-1.22-3.06-3.06-3.67-3.06-6.12c0-2.45,2.45-8.57,1.84-12.86 c-0.61-4.28-6.12-6.12-6.73-9.18c-0.61-3.06,1.22-11.02-3.06-14.69C163.89,354.78,154.1,350.5,153.49,353.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M173.4,413.72c-0.17,0-0.31-0.14-0.31-0.31c0-0.08-0.05-8.03-2.38-10.37c-2.36-2.37-3.71-9.6-4.37-23.46 c-0.6-12.6-9.63-22.97-9.72-23.07c-0.11-0.13-0.1-0.32,0.03-0.43c0.13-0.11,0.32-0.1,0.43,0.03c0.09,0.1,9.26,10.64,9.87,23.45 c0.64,13.51,1.98,20.84,4.2,23.06c2.51,2.51,2.56,10.46,2.56,10.8C173.71,413.59,173.57,413.72,173.4,413.72 C173.41,413.72,173.41,413.72,173.4,413.72z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M209.52,362.82c2.16,2.16-4.9,3.06-5.51,7.35c-0.61,4.29-0.61,6.12-3.06,8.57 c-2.45,2.45-6.12,3.06-5.51,6.73c0.61,3.67,1.84,7.35,0,9.18c-1.84,1.84-6.12,1.84-7.35,4.9c-1.22,3.06-0.61,6.73-3.06,9.79 c-2.45,3.06-6.12,9.18-9.18,7.96s-1.22-15.3,0-17.75c1.22-2.45,2.45-4.29,2.45-6.12s-0.61-4.9,0.61-7.96 c1.22-3.06,7.96-4.29,8.57-6.12c0.61-1.84,1.22-11.63,4.9-14.08C196.05,362.82,205.84,359.15,209.52,362.82z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M176.8,416.26c-0.05,0-0.11-0.01-0.16-0.04c-0.14-0.09-0.19-0.28-0.1-0.42c0.02-0.04,2.48-4.14,2.99-6.21 c0.13-0.53,0.29-1.34,0.48-2.28c0.68-3.4,1.7-8.53,3.27-10.11c2.28-2.28,5.93-9.28,8.49-18.23 c3.15-11.03,13.57-14.26,13.67-14.29c0.16-0.05,0.33,0.04,0.38,0.21c0.05,0.16-0.04,0.33-0.21,0.38 c-0.1,0.03-10.2,3.17-13.26,13.87c-2.59,9.05-6.31,16.16-8.65,18.5c-1.44,1.44-2.48,6.67-3.1,9.79 c-0.19,0.94-0.35,1.76-0.49,2.31c-0.54,2.16-2.96,6.21-3.06,6.38C177,416.2,176.9,416.26,176.8,416.26z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M176.02,369.83c-7.35,0.61-4.9,22.65-4.9,22.65c1.84,18.98,4.28,27.55,6.12,28.16 c1.84,0.61,5.51-26.93,5.51-33.67C182.75,386.97,183.36,369.22,176.02,369.83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M176.94,417.58c-0.01,0-0.03,0-0.04,0c-0.17-0.02-0.29-0.17-0.27-0.34c2.42-19.93-0.58-44.97-0.61-45.23 c-0.02-0.17,0.1-0.32,0.27-0.34c0.16-0.02,0.32,0.1,0.34,0.27c0.03,0.25,3.04,25.37,0.61,45.37 C177.22,417.47,177.09,417.58,176.94,417.58z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M186.06,431.52h-18.63c-0.62,0-1.15-0.38-1.22-0.88l-2.71-19.31c-0.12-0.87,0.55-1.65,1.43-1.65h23.61 c0.88,0,1.55,0.78,1.43,1.65l-2.71,19.31C187.21,431.14,186.68,431.52,186.06,431.52z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbducted);
export default __webpack_public_path__ + "static/media/abducted.9e82396052894828f1b1dd6b06670469.svg";
export { ForwardRef as ReactComponent };